module.exports = __webpack_public_path__ + "img/forum.81baf689.jpg";